"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getContextCurrent = exports.getContextOld = void 0;
const escrow_sdk_old_1 = require("escrow-sdk-old");
const index_1 = require("../../index");
const anchor_1 = require("@project-serum/anchor");
const getContextOld = (connection, wallet, programId) => {
    const commitment = "confirmed";
    const provider = new anchor_1.AnchorProvider(connection, wallet, { commitment });
    const ctx = escrow_sdk_old_1.EscrowContext.withProvider(provider, programId);
    return ctx;
};
exports.getContextOld = getContextOld;
const getContextCurrent = (connection, wallet, programId) => {
    const commitment = "confirmed";
    const provider = new anchor_1.AnchorProvider(connection, wallet, { commitment });
    const ctx = index_1.EscrowContext.withProvider(provider, programId);
    return ctx;
};
exports.getContextCurrent = getContextCurrent;
